/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DetailsDescription_deliverable$ref: FragmentReference;
declare export opaque type DetailsDescription_deliverable$fragmentType: DetailsDescription_deliverable$ref;
export type DetailsDescription_deliverable = {|
  +description: ?string,
  +$refType: DetailsDescription_deliverable$ref,
|};
export type DetailsDescription_deliverable$data = DetailsDescription_deliverable;
export type DetailsDescription_deliverable$key = {
  +$data?: DetailsDescription_deliverable$data,
  +$fragmentRefs: DetailsDescription_deliverable$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DetailsDescription_deliverable",
  "type": "DeliverableNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '016df540dcfe6f184cf64bc99cd7dfd0';
module.exports = node;
